// extracted by mini-css-extract-plugin
module.exports = {"card":"ra-card-news_card__Hppxw","card__content":"ra-card-news_card__content__GSmol","card__button":"ra-card-news_card__button__Q_ADr"};